// graphQL
export const URL_HIRER_GRAPH_LOCAL = `http://localhost:4000/graphql`;
